import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {OrgNodeSidebarModule} from '@q9elements/ui-kit/refmodels';
import {InternalSidebarModule} from '../internal-sidebar/internal-sidebar.module';

import {Q9DynamicComponentDirective} from '../shared/derectives/dynamic-component.directive';
import {SidebarHeaderModule} from './components/sidebar-header/sidebar-header.module';
import {SidebarWrapperComponent} from './sidebar-wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    SidebarHeaderModule,
    OrgNodeSidebarModule,
    InternalSidebarModule,
    Q9DynamicComponentDirective
  ],
  declarations: [SidebarWrapperComponent],
  exports: [SidebarWrapperComponent]
})
export class SidebarWrapperModule {}
